import React, {useEffect, useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import {Typography} from "@mui/material";
import {ContractHistoryTable} from "../tables/ContractHistoryTable";
import {PaymentHistoryTable} from "../tables/PaymentHistoryTable";
import {fetchPlayerHistory} from "../../containers/History";
import Button from "@mui/material/Button";

export const PlayerInfoDialog = ({open, playerRow, handleClose, handleOpenDropDialog, checkDroppable}) => {
    const [playerHistory, setPlayerHistory] = useState(null);
    const [paymentHistory, setPaymentHistory] = useState(null);
    const [showDropButton, setShowDropButton] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setPlayerHistory(null);
        setPaymentHistory(null);
        fetchPlayerHistory(playerRow, setLoading, setPlayerHistory, setPaymentHistory);
    }, [playerRow, playerRow.yahoo_id]);

    useEffect(() => {
        setShowDropButton(checkDroppable(playerRow.is_penalty));
    }, [playerRow.is_penalty, checkDroppable]);

    const onClickDropPlayer = () => {
        handleOpenDropDialog(playerRow.yahoo_id);
    };

    return (
        <Dialog open={open && !!playerHistory} onClose={handleClose} closeAfterTransition={false} maxWidth="md">
            <DialogTitle id="player-info-dialog">
                Player Info
            </DialogTitle>
            <DialogContent>
                {showDropButton &&
                    <Button variant="contained" type="submit" color="primary" style={{float: "right", width: 135}}
                            onClick={onClickDropPlayer}>Drop Player</Button>}
                <DialogContentText>
                    {`${playerRow.first_name} ${playerRow.last_name} - ${playerRow.pos} - ${playerRow.team}`}
                </DialogContentText>
                {loading && <LinearProgress color="secondary"/>}
                {playerHistory &&
                    <div style={{marginTop: 30}}>
                        <Typography variant="h6" color="inherit" display="inline" style={{marginLeft: 10}}>
                            Contract History:
                        </Typography>
                        <ContractHistoryTable playerHistory={playerHistory}/>
                    </div>}
                {paymentHistory &&
                    <div style={{marginTop: 40}}>
                        <Typography variant="h6" color="inherit" display="inline" style={{marginLeft: 10}}>
                            Payment History:
                        </Typography>
                        <PaymentHistoryTable paymentHistory={paymentHistory}/>
                    </div>}
            </DialogContent>
        </Dialog>
    );
}